"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "m20.5282 10.5787-2.1321 2.132-1.4142-1.4142 2.1321-2.132c1.1814-1.1815 1.1814-3.097 0-4.2784-1.1815-1.1815-3.097-1.1815-4.2784 0l-3.5534 3.5534c-1.1814 1.1814-1.1814 3.0969 0 4.2783L9.868 14.132c-1.9625-1.9624-1.9625-5.1442 0-7.1067l3.5534-3.5534c1.9625-1.9625 5.1443-1.9625 7.1068 0 1.9624 1.9625 1.9624 5.1443 0 7.1068z"
  }), _react.default.createElement("path", {
    d: "m5.604 11.2893 1.414 1.4142-2.132 2.1321c-1.1814 1.1814-1.1814 3.0969 0 4.2783 1.1815 1.1815 3.097 1.1815 4.2784 0l3.5534-3.5534c1.1814-1.1814 1.1815-3.0969 0-4.2783l1.4143-1.4142c1.9624 1.9625 1.9624 5.1443-.0001 7.1067l-3.5534 3.5534c-1.9624 1.9625-5.1443 1.9625-7.1067 0-1.9625-1.9624-1.9625-5.1443 0-7.1068l2.132-2.132z"
  })];
};

exports.default = _default;